import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NavDropdown as BNavDropdown } from 'react-bootstrap';
import useBreakpoint from '../../hooks/useBreakpoint';
import './NavDropdown.scss';


const CustomNavDropdown = ({
  title,
  children,
  onClick,
  className,
  ...params
}) => {
  const breakpoint = useBreakpoint();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  /**
   * If the click on the body is not over the dropdown element, automatically closes it
   */
  const onClickBody = useCallback((event) => {
    const id = `#${params.id}`;
    if (!$(event.target).closest(id).length) {
      setOpen(false);
    }
  }, [open]);

  useEffect(() => {
    $(document).on('click', onClickBody);
    return () => {
      $(document).off('click', onClickBody);
    };
  }, []);

  const handleClick = useCallback((event) => {
    if (onClick) {
      onClick(event);
    }
    setOpen(!open);
  }, [onClick, open]);

  const customTitle = <div>
    <span>
      {title}
    </span>
    {
      breakpoint === 'xs'
        ? <i className={classNames('fal ml-2', { 'fa-minus': open, 'fa-plus': !open })} />
        : null
    }
  </div>;

  return (<BNavDropdown
    className={classNames('custom-nav-dropdown', className)}
    title={customTitle}
    onClick={handleClick}
    ref={dropdownRef}
    id={params.id}
    {...params}>
    {children}
  </BNavDropdown>);
};

export default React.memo(CustomNavDropdown);